export default "__VITE_ASSET__cc828531__"